import type { ColumnDef } from "@tanstack/react-table";
import { buildActionColumn, buildTagColumn } from "@/components/Table";
import type { TagType } from "@/components/Tag/Tag";
import { renderEmptyCellState } from "@/components/Table/utils";
import { actionId } from "@/hooks/useTableRowMenu";
import { toUTCFormat } from "@/lib/dateHelpers";
import { formatEnumLabel } from "@/pages/billing/finance/commission/_utils";
import type { PersonGrpFaaRow } from "../types";

function consentStatusType(status: PersonGrpFaaRow["status"]): TagType {
  if (status === "ACTIVE") return "success";
  if (status === "ENDED") return "surface";
  return "warn";
}

export function getFaaColumns({
  onViewClick
}: {
  onViewClick: (row: PersonGrpFaaRow) => void;
}): ColumnDef<PersonGrpFaaRow, unknown>[] {
  return [
    {
      id: "sponsor",
      accessorFn: (row) => row.partnerName,
      header: "Sponsor",
      size: 220,
      enableSorting: false,
      cell: ({ row }) => renderEmptyCellState(row.original.partnerName)
    },
    {
      accessorKey: "attributionModel",
      header: "Attribution",
      size: 140,
      enableSorting: false,
      cell: ({ row }) => renderEmptyCellState(formatEnumLabel(row.original.attributionModel))
    },
    {
      accessorKey: "ownership",
      header: "Plan Option",
      size: 120,
      enableSorting: false,
      cell: ({ row }) =>
        renderEmptyCellState(row.original.ownership ? formatEnumLabel(row.original.ownership) : undefined)
    },
    {
      accessorKey: "startsAt",
      header: "Effective Date",
      size: 120,
      cell: ({ row }) => renderEmptyCellState(toUTCFormat(row.original.startsAt))
    },
    {
      accessorKey: "endsAt",
      header: "Expiration Date",
      size: 120,
      cell: ({ row }) => renderEmptyCellState(row.original.endsAt ? toUTCFormat(row.original.endsAt) : undefined)
    },
    buildTagColumn<PersonGrpFaaRow>({
      accessorKey: "status",
      header: "Status",
      size: 120,
      getTagLabel: (row) => formatEnumLabel(row.status),
      getTagType: (row) => consentStatusType(row.status),
      getTagStyle: () => "strong"
    }),
    buildActionColumn<PersonGrpFaaRow>({
      onViewClick,
      showViewButton: () => true,
      viewButtonTitle: "View FAA details",
      actionId,
      setMenu: () => {}
    })
  ];
}
